import React from 'react';
import MetricTab from './MetricTab';
import TabPanel from './TabPanel';

type Props = {
    metrics: QueryMetricT[];
    selectedMetric: QueryMetricT;
    chartTitle: string;
    detailsData: ResponseDataT[];
    detailsColumns: ResponseColumnT[];
    exportToFile: () => void;
    isLoading: boolean;
};

const ModalContent = ({
    metrics,
    selectedMetric,
    detailsData,
    detailsColumns,
    exportToFile,
    isLoading,
}: Props): React.ReactElement[] =>
    metrics.map((m) => (
        <TabPanel
            key={m.field + m.aggregation}
            value={selectedMetric.field}
            index={m.field}
        >
            <MetricTab
                columns={m.field === selectedMetric.field ? detailsColumns : []}
                data={m.field === selectedMetric.field ? detailsData : []}
                exportToFile={exportToFile}
                isLoading={isLoading}
            />
        </TabPanel>
    ));

const MemoModalContent = React.memo<Props>(ModalContent);
export default MemoModalContent;
